import CareersRegisterRadio from "../registration/CareersRegisterRadio";
import React, { useState, useEffect, useRef } from "react";
import { Formik, Field, Form } from "formik";
import Select from "react-select";
import { RoundCheckbox, errorMessage, PassportRadio } from "../../constants/registration";
import registrationData from "./registrationData.json";
import * as Constants from "../../constants/registration";
import { Row, Col } from "react-bootstrap";
import CareersRegisterControl from "./CareersRegisterControl";
//Regex
import {
  no_Numbers,
  no_special_characters,
  mobile_number,
  alphabet_Check,
} from "../../constants/registration";
import { useNavigate } from "react-router-dom";
import CareersRegisterOtpVerifyScreen from "./CareersRegisterOtpVerifyScreen";
import {
  getEducationLevelField, getInterestedInField,
  getCourseJoinPreferenceField, postSignUpData, getTertiaryCheckboxData, getAreaOfInterestField,
  getTargetedCountriesField
} from "../../../store/slices/Registration/SignUpSlices";
import { connect } from "react-redux";
import { createCurrentUrl, placeholderData, convertToTitleCase } from "../../utils/registrationUtils";
import * as actionTypes from "../../../store/slices/Registration/SignUpSlices"
import {
  postUserLoginSignupOtp,
  getUserAuthentication,
  postLoginData,
  getCountryCodeData,
  getUserAuthenticationEmail,
  getUserAccountLimitCheck
} from "../../../store/slices/Registration/CommonSlices";
import CommonModal from "../../components/utils/commonModal";
import logo from "../../assets/images/register/logo.svg";
import Cookies from "universal-cookie";
import { getCurrentMonth, getAbsoluteDestinationUrl, certificationPage, IdsCheck } from "../../utils/registrationUtils"
import ReactGA from "react-ga";
import SetInnerHtml from "../utils/setInnerHtml";
import axios from "axios"
import DataLayerEvents from "../common/DataLayerEvents";
import { gaEvent, gaLocationAndContentData } from "../../utils/index";

const CareersRegisterSignUp = (props) => {
  const [radioBtn, setRadioBtn] = useState([]);
  const [interestedInCheckbox, setInterestedInCheckbox] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [formikValues, setFormikValues] = useState({});
  const [isConsentChecked, setIsConsentChecked] = useState(true);
  const [fieldErrors, setFieldErrors] = useState({});
  const [tertiaryData, setTertiaryData] = useState([]);
  const [editMobile, setEditMobile] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [touchedFields, setTouchedFields] = useState({})
  const [reloadFlag, setReloadFlag] = useState(true)
  // const location = useLocation();
  const cookies = new Cookies();
  let date = new Date();
  const navigate = useNavigate();
  const [formCurrentState, setFormCurrentState] = useState(cookies.get("registrationState"));
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  const [reinitialize, setReinitialize] = useState(true)
  const [syncSignupValues, setSyncSignupValues] = useState({});
  const [currentFields, setCurrentFields] = useState(0);
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify", "/user/update-profile", "user/login/otp-verify"];
  const currentDeferrerUrl = document.referrer
  const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
  let currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  if(!currentUrl){
    currentUrl = sourseDestination; // when no currenturl, case on click of url on exam page from data.
  }
  // Checks to show tertiary checbox data.
  let targetYearCheck = (props.domain?.id == 3 || props.domain?.id == 4) ? formikValues?.education_level?.id > 13 : false;
  let targetYearValue = targetYearCheck ? formikValues?.target_year : true;
  let tertairyCheckboxShow = formikValues?.education_level && formikValues?.location?.id && targetYearValue && (formikValues?.education_interest || formikValues?.aspiring_stream);
  //---------------------------------------    
  const preferredLevelStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefferred_level_streams;
  // const preferredStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.preffered_streams;
  // adding events based on current filled fields.
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Cancel the event to prevent the page from refreshing immediately
      event.preventDefault();
    };
    if (reloadFlag && currentFields > 1 && window.location.pathname.includes("/user/register")
      && props.reloadFlagOnExit) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }
    return (() => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    })
  }, [reloadFlag, currentFields, props.reloadFlagOnExit])
  // for setting 15 mins time for page expiry with all events checked.
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Cancel the event to prevent the page from refreshing immediately
      event.preventDefault();
    };
    if (!reloadFlag) {
      if (props.loginDatas?.proceed == true) {
        window.location.href = props.loginDatas?.destination
      } else if (!window.location.pathname?.includes('user/otp-verify')) {
        navigate(`/user/otp-verify${window.location.search}`)
        window.history.pushState(null, "", window.location.href);
      } else {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    }
  }, [reloadFlag, props.loginDatas])

  useEffect(() => {
    setTimeout(() => setReinitialize(false), 500); //do not remove this line.
    CallingOnLOadApiActions();
    // to save values in cookies
    let valuesToPopulate = window.location.pathname.includes("user/otp-verify") ? formCurrentState : cookies.get("common_embbed_fields");
    if (valuesToPopulate) {
      if (valuesToPopulate?.currentScreen?.page === 'signup' && valuesToPopulate?.postSignupData) {
        props.dispatch(actionTypes.postSignupDataSuccess(valuesToPopulate?.postSignupData))
        setIsClicked(true)
      }
      if (valuesToPopulate?.errors) {
        setFieldErrors(valuesToPopulate?.errors)
      }
      if (valuesToPopulate?.touched) {
        const filteredTouched = {};
        Object?.keys(valuesToPopulate?.formValues)?.forEach((key) => {
          if (valuesToPopulate?.touched[key] && valuesToPopulate?.formValues[key]) {
            filteredTouched[key] = valuesToPopulate?.touched[key];
          }
        });
        setFormCurrentState((prev) => ({ ...prev, touched: filteredTouched }));
        setTouchedFields(filteredTouched);
      };
      let SignupCookies = valuesToPopulate?.formValues;
      let obj = {}
      let primaryFields = ["studentname", "email", "mobile", "location", "education_level"]
      SignupCookies && Object?.keys(SignupCookies)?.filter((key) => {
        if (primaryFields?.includes(key)) {
          obj[key] = SignupCookies[key]
        }
      })
      setFormikValues(obj)
      setTouchedFields({ ...valuesToPopulate?.touched, education_level: false });
    }
    // url added for browser back button redirection.
    window.history.pushState(null, "", window.location.href);
    const handlePopstate = (event) => {
    window.location.href =  currentUrl ? currentUrl : getAbsoluteDestinationUrl();
    };
    window.onpopstate = handlePopstate;

    return () => {
      window.onpopstate = handlePopstate; // Clean up the event handler
    };
  }, []);
  useEffect(() => {  //user auth check mobile
    if (formikValues?.mobile && !fieldErrors?.mobile) {
      let params = {};
      params.mobile_number = formikValues?.mobile
      props.dispatch(getUserAuthentication(params));
    }
  }, [formikValues?.mobile, fieldErrors?.mobile])

  useEffect(() => {  //user auth check email
    if (formikValues?.email && !fieldErrors?.email) {
      let params = {};
      params.email = formikValues?.email;
      if (window.location.pathname?.includes("user/otp-verify")) {
        params.check_otp = 1;
      }
      props.dispatch(getUserAuthenticationEmail(params));
    }
  }, [formikValues?.email, fieldErrors?.email])

  useEffect(() => {
    if(formikValues?.mobile && !fieldErrors?.mobile && formikValues?.email && !fieldErrors?.email){
      let params = {};
      params.mobile_number = formikValues.mobile;
      params.email = formikValues.email;
      props.dispatch(getUserAccountLimitCheck(params))
    }
  }, [formikValues?.mobile, fieldErrors?.mobile, formikValues?.email, fieldErrors?.email])

  useEffect(() => { //tertiary checkbox

    if (props.geolocationData && window.location.pathname.includes("/user/register")) {
      let params = {};
      params.url = sourseDestination;
      params.state_id = formikValues?.location?.state_id;
      params.level_id = formikValues?.education_level?.id;
      if (formikValues?.education_interest)
        params.education_stream = formikValues?.education_interest.domain_id;
      if (formikValues?.aspiring_stream)
        params.aspiring_stream = formikValues?.aspiring_stream?.id;
      if (formikValues?.target_year)
        params.target_year = formikValues?.target_year?.id;
      if (formikValues?.passing_year)
        params.passing_year = formikValues?.passing_year?.id;
      if (tertairyCheckboxShow) {
        props.dispatch(getTertiaryCheckboxData(params))
      }
    }
  }, [props.geolocationData, formikValues?.education_level, formikValues?.location, formikValues?.target_year, formikValues?.aspiring_stream, formikValues?.education_interest])
  // handling prefilled data for certification domain for checkboxes
  useEffect(() => {
    if (props.dropdownData?.interested_in) {
      setInterestedInCheckbox(props.dropdownData?.interested_in?.values)
      if (props.domain.id == 2) {
        let updatedCheckBoxes = props.dropdownData?.interested_in?.values?.filter((obj, ind) => {
          if ([1, 2].includes(obj.preference_id)) {
            return obj
          }
        })
        setFormikValues((prev) => ({ ...prev, "interested_in": updatedCheckBoxes }))
        setReinitialize(true)
        setTimeout(() => setReinitialize(false), 50);
      }
    }
  }, [props.dropdownData?.interested_in])
  // set Tertiary radio data
  useEffect(() => {
    if (props.tertiaryChecboxData) {
      setTertiaryData(RoundCheckbox)
    }
  }, [props.tertiaryChecboxData])

  // set radio button options data for course joining preference
  useEffect(() => {
    if (props.dropdownData?.course_joining_preference && props.domain?.id == 2) {
      setRadioBtn(props.dropdownData?.course_joining_preference?.values)
    }
  }, [props.dropdownData?.course_joining_preference])

  useEffect(() => { //navigation to otp verify screen 
    if (props.postSignupData?.proceed && isClicked && props.usersAuthentication) {
      TotalFieldsData(formikValues, "GA");
      otpGetClickedMobile();
      if (!window.location.pathname?.includes('user/otp-verify')) {
        setReloadFlag(false)
        setFormCurrentState((prev) => ({ ...prev, postSignupData: props.postSignupData }));
      }
    }
  }, [props.postSignupData])
  useEffect(() => {
    if (formCurrentState) {
      if (!cookies.get("common_embbed_fields")?.formValues?.user_uuid) {
        setSyncSignupValues((prev) => ({ ...prev, "user_uuid": props.postSignupData?.user_uuid }))
      }
      var date = new Date();
      date.setDate(date.getDate() + 3); // Setting expiration date to 3 day ahead
      cookies.set("registrationState", formCurrentState, {
        path: "/",
        expires: date, // Passing the Date object
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location.hostname : destinationDomain,
      });
    }
  }, [formCurrentState]);
  useEffect(() => {
    let obj = {}
    obj.formValues = { ...cookies.get("common_embbed_fields")?.formValues, ...syncSignupValues }
    if (Object.keys(syncSignupValues)?.length > 0) {
      var date = new Date();
      date.setDate(date.getDate() + 3); // Setting expiration date to 3 day ahead
      cookies.set("common_embbed_fields", obj, {
        path: "/",
        expires: date, // Passing the Date object
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location.hostname : destinationDomain,
      });
    }
  }, [syncSignupValues]);

  useEffect(() => {
    if (props.usersLoginSignupOtpError) {
      setEditEmail(true);
      setFormCurrentState((prev) => ({
        ...prev, isEmailEditing: true
      }))
    }
  }, [props.usersLoginSignupOtpError])

  useEffect(() => { //to clear edit mobile on successful otp response
    if (props.usersLoginSignupOtp?.otp_on == "mobile" || props.usersLoginSignupOtpError?.block_user_case === "try_again") {
      setEditMobile(false);
      setFormCurrentState((prev) => ({
        ...prev, isMobileEditing: false
      }))
    }
    if (props.usersLoginSignupOtp?.otp_on == "email" || props.usersLoginSignupOtpError?.block_user_case === "try_again") {
      setEditEmail(false);
      setFormCurrentState((prev) => ({
        ...prev, isEmailEditing: false
      }))
    }
  }, [props.usersLoginSignupOtp, props.usersLoginSignupOtpError])


  const CallingOnLOadApiActions = () => {
    let preferedEducationLevel = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefered_education_level;
    if (props.domain.id == 3) {
      setRadioBtn(PassportRadio);
    }
    let params = {};
    params.current_url = currentUrl;
    params.page_url = sourseDestination;
    params.certification = props.domain?.id == 2 ? "True" : "False";
    props.dispatch(getCountryCodeData({ ...params, field: "country_code" }));
    if (window.location.pathname.includes("/user/register")) {
      let paramLevel = { ...params }
      paramLevel.field = "education_level";
      if (preferedEducationLevel) {
        paramLevel.preferred_level = typeof preferedEducationLevel === 'object' ? Object.keys(preferedEducationLevel)?.[0] : preferedEducationLevel;
      }
      props.dispatch(getEducationLevelField(paramLevel));
      if (props.domain?.id != 1 && props.domain?.id != 5) props.dispatch(getInterestedInField({ ...params, field: "interested_in" }));
      if (props.domain?.id == 2) props.dispatch(getCourseJoinPreferenceField({ ...params, field: "course_joining_preference" }));
      if (props.domain?.id == 3) props.dispatch(getTargetedCountriesField({ ...params, field: "country" }))
    };
  }

  const otpGetClickedMobile = () => { //to send otp for mobile
    if ((Object.keys(fieldErrors)?.length === 0 || window.location.pathname.includes("/user/otp-verify"))
      && props.usersAuthentication) {
      let params = {};
      params.otp_on = "mobile";
      params.cta_clicked = "signup";
      params.otp_action = "send";
      params.isd_code = "+91";
      params.mobile_number = formikValues?.mobile;
      props.dispatch(postUserLoginSignupOtp(params));
    }
  };
  const otpGetClickedEmail = () => {  // to send otp for email
    let params = {};
    params.otp_on = "email";
    params.cta_clicked = "signup";
    params.otp_action = "send";
    params.email = formikValues?.email
    props.dispatch(postUserLoginSignupOtp(params));
  };

  const validate = (values) => {
    let errors = {};

    //email
    if (!values.email) {
      errors.email = "Please enter your email.";
    }
    else if (!/^(?!.*\.{2})[a-zA-Z0-9._%+-]+@(?!\.)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(values.email) || (values?.email?.[0] == '.') ||
      !/^[^@\s]*@?[^@\s]*$/.test(values.email) // allow only one @ character
    ) {
      errors.email = "Invalid Email. Please update.";
    }
    //mobile

    if (!values.mobile) {
      errors.mobile = "Please enter your mobile number.";
    }
    else if (mobile_number.test(values.mobile)) {
      errors.mobile = "Invalid mobile. Must start with 6,7,8,9.";
    }
    else if (values.mobile?.length != 10) {
      errors.mobile = "Invalid mobile. Must have 10 digits.";
    }
    else if (no_special_characters.test(values.mobile)) {
      errors.mobile = "Invalid mobile. No special character accepted.";
    }
    else if (alphabet_Check.test(values.mobile)) {
      errors.mobile = "Invalid mobile. Aplhabets are not allowed.";
    }

    //name
    if (!values.studentname && props.domain?.id == 1) {
      errors.studentname = "Please enter student's name.";
    }
    else if (!values.studentname && props.domain?.id != 1) {
      errors.studentname = "Please enter your name.";
    } else {
      if (no_Numbers.test(values.studentname?.trim())) {
        errors.studentname = "Name should not contain numbers.";
      }
      if (no_special_characters.test(values.studentname?.trim())) {
        errors.studentname = "Name should not contain special character.";
      }
      if (values.studentname?.trim().length < 2 || values.studentname?.trim().length > 60) {
        errors.studentname = "Invalid name. Please enter 2 to 60 characters.";
      }
    }

    //targeting countries
    if (!values.country && props.domain?.id == 3) {
      errors.country = "Please select your interested countries."
    }

    //cty

    if (!values.location?.id) {
      errors.location = "Please search & select your city from the list.";
    }
    if (!values.education_level) {
      errors.education_level = "Please select what you are currently doing."
    }
    if (props.domain?.id == 2 && (!values.interested_in || values.interested_in?.length === 0)) {
      errors.interested_in = "Please select your interest."
    }
    registrationData?.data
      ?.find((obj) => obj.domain == props.domain?.id)
      ?.fields?.map((item, index) => {

        let interestedInFields = Array.isArray(values?.interested_in) && values?.interested_in?.length > 0 &&
          values.interested_in?.find((obj) =>
            item.interested_in?.includes(obj.preference_id)
          );

        let isTotalFields = item.dependency_type == "AND"
          ? item.education_level?.includes(values?.education_level?.id)
          && item.interested_in?.includes(interestedInFields?.preference_id)
          : item.education_level?.includes(values?.education_level?.id);

        let renderField = false
        if (item.name == "passing_year") {
          if (["March", "April"]?.includes(getCurrentMonth()) || values?.education_level?.id == 13) {
            renderField = true
          }
        } else {
          renderField = true
        }
        if (isTotalFields && renderField) {
          let fieldName = convertToTitleCase(item.name);
          let labelMatched = errorMessage.find((error) => error.label === item.name);
          if (item.name != "interested_in" && (!values[item.name] || values[item.name].length === 0)) {
            if (item.name == "aspiring_stream" && values.education_level?.id <= 10) {
              errors.aspiring_stream = "Please select interested subjects' stream."
            }
            else if (item.name == "aspiring_stream" && values.education_level?.id > 10) {
              errors.aspiring_stream = "Please select your current stream in school."
            }
            else if (item.name == "education_interest" && values.education_level?.id <= 10) {
              errors.education_interest = "Please select your interested stream for college."
            }
            else if (item.name == "education_interest" && values.education_level?.id >= 11) {
              errors.education_interest = "Please select course interest for college."
            }
            else if (item.name == "degree_pursue" && ((values?.education_level?.id >= 22 && values?.education_level?.id <= 25) || values?.education_level?.id > 28)) {
              errors.degree_pursue = "Please select your completed degree."
            }
            else {
              errors[item.name] = labelMatched ? labelMatched.message : `${fieldName} field is required.`
            };
          }
        }
      });

    setFormCurrentState((prev) => ({ ...prev, errors }))
    return errors;
  };

  const updateTouchedFields = (touched) => {
    setFormCurrentState((prev) => ({ ...prev, touched }))
  }

  const handleConsentCheckboxChange = (event) => {
    setIsConsentChecked(event.target.checked);
  };

  const TotalFieldsData = (values, click) => {
    let fieldsCount = registrationData?.data
      ?.find((obj) => obj.domain == props.domain?.id)
      ?.fields?.filter((item, index) => {
        let interestedInFields = Array.isArray(values?.interested_in) && values?.interested_in?.length > 0 && values.interested_in?.find((obj) =>
          item.interested_in?.includes(obj.preference_id))
        let isTotalFields = item.dependency_type == "AND" ? item.education_level?.includes(values?.education_level?.id)
          && item.interested_in?.includes(interestedInFields?.preference_id) :
          item.education_level?.includes(values?.education_level?.id)
        if (item.name == "area_of_interest" && !(values?.certificate_interest || values?.education_interest)) {
          isTotalFields = false
        }
        let renderField = false
        if (item.name == "passing_year") {
          if(values?.education_level?.id == 12 && ["March", "April", "May", "June", "July", "August", "September", "October"]?.includes(getCurrentMonth())){
            renderField = true
          }
          if (values?.education_level?.id !== 12 && (["March", "April"]?.includes(getCurrentMonth()) || values?.education_level?.id == 13)) {
            renderField = true
          }
        } else {
          renderField = true
        }

        if ((item.type == "Primary" || isTotalFields) && renderField) {
          return item;
        }
      })
    if(click == "GA"){
      props.setCurrentFieldsCount(fieldsCount?.length);
      gaEvent("signupsubmit", "login_signup", `${gaLocationAndContentData}`, `${fieldsCount?.length}`);
    }
    return fieldsCount;
  }

  return (
    <>
      <div>
        <Formik
          initialValues={formikValues}
          // validationSchema={schema}
          enableReinitialize={reinitialize}
          validate={validate}
          onSubmit={(values, { setSubmitting }) => {
            const errors = validate(values);
            setFieldErrors(errors);
          }}
          initialTouched={touchedFields}
          initialErrors={fieldErrors}
        >
          {({
            formik,
            values,
            handleChange,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            validateForm,
            setTouched
          }) => {

            useEffect(() => {
              setFormikValues(values);
              setFormCurrentState((prev) => ({ ...prev, formValues: values }))
              const errors = validate(values);
              setFieldErrors(errors);
              countCurrentFields()
            }, [values]);

            const countCurrentFields = () => {
              let count = 0
              let primaryFields = ["studentname", "email", "mobile", "location"]
              for (const key in values) {
                if (values.hasOwnProperty(key) && values[key] !== null && !primaryFields.includes(key)) {
                  count = count + 1
                  setCurrentFields(count);
                }
              }
            }

            const signupDataPost = () => {   // for signup post api where all fileds data is needed
              const userUuid = cookies.get("common_embbed_fields")?.formValues?.user_uuid || formCurrentState?.postSignupData?.user_uuid;
              const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
              if (Object.keys(errors).length === 0 && props.usersAuthentication && props.userAuthenticationEmail) {
                setIsClicked(true);
                let obj = {};
                obj.current_url = currentUrl;
                obj.page_url = sourseDestination 
                obj.destination = destinationUrl;
                obj.cta_clicked = "signup";
                obj.country_code = "+91";
                obj.mobile_number = values?.mobile;
                obj.location = values?.location?.id;
                obj.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
                obj.email = values?.email;
                obj.education_level = values?.education_level?.id;
                obj.name = values?.studentname?.trim();
                obj.submit = true;
                obj.interested_in = values.interested_in?.length > 0 ? IdsCheck(values?.interested_in) : [];
                obj.checkbox_id = props.tertiaryChecboxData?.id ?? 0;
                obj.checkbox_status = values?.tertiary_checkbox?.[0]?.id == 1 ? true : false;
                if (userUuid) {
                  obj.user_uuid = userUuid;
                }
                if (values?.passing_year)
                  obj.passing_year = values?.passing_year?.id;
                if (values?.aspiring_stream)
                  obj.aspiring_stream = values?.aspiring_stream?.id;
                if (values?.degree_pursue)
                  obj.degree_pursue = values.degree_pursue?.id;
                if (values?.target_year)
                  obj.target_year = values.target_year?.id;
                if (values?.work_experience)
                  obj.work_experience = JSON.stringify(values.work_experience?.id);
                if (values?.education_interest) {
                  if (values?.education_interest?.id)
                    obj.degree_interested = values?.education_interest?.id
                  if (values?.education_interest?.group_id) {
                    obj.is_group = true;
                  }
                  obj.domain_id = values?.education_interest?.domain_id;
                };
                if (values.passport?.length > 0)
                  obj.passport = values.passport?.[0]?.id;
                if (values.course_joining_preference)
                  obj.course_joining_preference = values?.course_joining_preference?.[0]?.id;
                if (values.area_of_interest?.length > 0)
                  obj.area_of_interest = values?.area_of_interest;
                if (values?.country?.length > 0)
                  obj.country = IdsCheck(values?.country);
                if (values.certificate_interest)
                  obj.certificate_interest = values.certificate_interest?.domain_id;
                obj.certification = props.domain?.id == 2 ? true : false;
                if(values?.school_board?.id){
                  obj.school_board = values?.school_board?.id
                }
                setFormCurrentState((prev) => ({
                  ...prev, currentScreen: {
                    page: 'signup',
                    screen: 2,
                    postSignUpParams: obj
                  }
                }))
                props.dispatch(postSignUpData(obj));
              }
            };

            const handleInterestedCheckbox = (item, id) => { //checkbox
              const updatedCheckboxes = interestedInCheckbox?.map((checkbox) =>
                checkbox.preference_id === id
                  ? { ...checkbox, selected: !checkbox.selected }
                  : checkbox
              );
              setInterestedInCheckbox(updatedCheckboxes);
              setFieldValue(
                item?.name,
                updatedCheckboxes?.filter((obj) => obj.selected)
              );
            };

            const handleRadioChange = (item, id) => { //radio
              const updatedCheckboxes = radioBtn?.map((checkbox) => ({
                ...checkbox,
                selected: checkbox.id === id,
              }));
              setRadioBtn(updatedCheckboxes);
              setFieldValue(
                item?.name,
                updatedCheckboxes?.filter((obj) => obj.selected)
              );
            };
            const handleTertiaryChange = (item, id) => { //for tertiary radio 
              const tertiaryRadio = tertiaryData?.map((checkbox) => ({
                ...checkbox,
                selected: checkbox.id === id,
              }));
              setTertiaryData(tertiaryRadio)
              setFieldValue(
                "tertiary_checkbox",
                tertiaryRadio?.filter((obj) => obj.selected)
              );
            }
            // need to remove 
            const handleOnFocus = (event, name, item) => {
              console.log("");
            }
            // call updated fields api based on education level
            const apiCallBasedOnStudyingIn = (name, option) => {
              values = { ...values, [name]: option }
              updateTouchedFields({ ...touched, [`${name}`]: true })
              
              if (TotalFieldsData(values)?.length > 0) {
                // Dynamically call the actions
                TotalFieldsData(values)?.forEach((obj) => {
                  const actionCreator = actionTypes[obj.actionName];
                  
                  if (typeof actionCreator === 'function' && !["interested_in", "course_joining_preference", "passport"]?.includes(obj.name)) {
                    
                      let params = {};
                      params.current_url = currentUrl;
                      params.page_url = sourseDestination;
                      params.certification = props.domain?.id == 2 ? "True" : "False";
                      if (values?.education_level?.id)
                        params.education_level = values?.education_level?.id;

                      if (values.interested_in?.length > 0)
                        params.interested_in = `${IdsCheck(values?.interested_in)?.join(',')}`;
                      if(obj.name == "education_interest" && preferredLevelStreamData?.length > 0){ 
                         params.preferred_stream_level = JSON.stringify(preferredLevelStreamData);
                      // if (preferredStreamData?.length > 0) params.preferredStreamData = JSON.stringify(preferredStreamData);
                      }
                    // Dispatch the action here or call it directly
                    params.field = `${obj.name}`;
                    if(name == "education_interest"){
                      if(obj.name == 'target_year'){
                        params.domain_id = option?.domain_id;
                        sessionStorage.setItem("up_domain_id",option?.domain_id)
                        props.dispatch(actionCreator(params));
                      }
                    }else{
                        props.dispatch(actionCreator(params));
                    }
                  }
                })
              };
            };

            const otpSubmitMobile = () => { // to send user filled otp for mobile in login api
              const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
              let params = {};
              params.current_url = currentUrl;
              params.page_url = sourseDestination;
              params.destination = destinationUrl
              params.certification = props.domain?.id == 2 ? true : false;
              params.cta_clicked = "signup",
                params.otp_on = "mobile";
              params.country_code = "+91";
              params.mobile_number = values.mobile;
              if (values.otp)
                params.otp = parseInt(values.otp);
              if (props.loginDatas?.required_field?.includes("email_confirm"))
                params.email_confirm = true;
              if (props.postSignupData) {
                params.user_uuid = props.postSignupData?.user_uuid;
              }
              props.dispatch(postLoginData(params));
            }

            const otpSubmitEmail = () => { // to send user filled otp for mobile in login api
              const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
              let params = {};
              params.current_url = currentUrl;
              params.page_url = sourseDestination;
              params.destination = destinationUrl;
              params.certification = props.domain?.id == 2 ? true : false;
              params.cta_clicked = "signup";
              params.otp_on = "email";
              params.country_code = "+91";
              params.mobile_number = values.mobile;
              params.email = values.email;
              if (values.otp)
                params.otp = parseInt(values.otp);
              if (props.loginDatas?.required_field?.includes("email_confirm"))
                params.email_confirm = true;
              if (props.postSignupData)
                params.user_uuid = props.postSignupData?.user_uuid;
              props.dispatch(postLoginData(params))
            }

            const areaOfInterestApiCall = (level = values?.education_level, interest = values.interested_in,
              eduInterest = values?.education_interest, cerInterest = values?.certificate_interest) => {
              let params = {};
              updateTouchedFields({ ...touched, ["area_of_interest"]: true })
              params.current_url = currentUrl;
              params.page_url = sourseDestination;
              params.field = "area_of_interest";
              // Set certification based on the domain id
              params.certification = props.domain?.id == 2 ? "True" : "False";

              // Add education level id to params if it exists
              if (level?.id)
                params.education_level = level?.id;

              // Add degree interested and domain id if education interest and specific conditions are met
              if (eduInterest && (interest?.[0]?.preference_id ? IdsCheck(interest)?.includes(1) : interest?.includes(1))) {
                if (eduInterest?.id)
                  params.degree_interested = eduInterest?.id
                if (eduInterest?.group_id) {
                  params.is_group = true;
                }
                params.domain_id = eduInterest?.domain_id;
              };
              // Add interested_in to params if interest array is not empty
              if (interest?.length > 0)
                params.interested_in = interest?.[0]?.preference_id ? `${IdsCheck(interest)?.join(',')}` : interest?.length > 0 ? interest?.join(',') : [];

              // Add certificate interest to params if conditions are met
              if (cerInterest && (interest?.[0]?.preference_id ? IdsCheck(interest)?.includes(2) : interest?.includes(2))) {
                params.certificate_interest = cerInterest?.domain_id;
              }
              props.dispatch(getAreaOfInterestField(params))
            }

            return (
              <><Form onSubmit={handleSubmit}>

                {window.location.pathname.includes("/user/register") && (
                  <>
                    <DataLayerEvents contentType={"Login/Signup"} pageTypes={"signup"} verticalName={props.domain?.domain} />
                    <Row>
                      {TotalFieldsData(values)?.map((item, index) => {
                          
                            return (
                              <Col
                                md={
                                  item.fieldType == "checkbox" ||
                                    item.fieldType == "radio"
                                    ? "12"
                                    : "6"
                                }
                              >
                                <CareersRegisterControl
                                  item={item}
                                  control={item?.fieldType}
                                  name={item?.name}
                                  label={item?.label}
                                  handleChange={handleChange}
                                  setFieldValue={setFieldValue}
                                  values={values}
                                  errors={errors}
                                  fieldErrors={fieldErrors}
                                  touched={touched}
                                  constants={Constants[item?.options]}
                                  fieldSelectType={item?.fieldSelectType}
                                  placeholder={placeholderData(item, values)}
                                  maxLimit={item?.maxLimit}
                                  handleBlur={handleBlur}
                                  dropdownData={props.dropdownData[item.name]}
                                  domain={props.domain}
                                  interestedInCheckbox={interestedInCheckbox}
                                  setInterestedInCheckbox={setInterestedInCheckbox}
                                  handleInterestedCheckbox={(e, id) =>
                                    handleInterestedCheckbox(item, id)
                                  }
                                  radioBtn={radioBtn}
                                  handleRadioChange={(e, id) => handleRadioChange(item, id)}
                                  handleOnFocus={(event) => handleOnFocus(event, item.name, item)}
                                  searchBar={item.searchBar}
                                  geolocationData={props.geolocationData}
                                  updateTouchedFields={updateTouchedFields}
                                  setTouched={setTouched}
                                  setFormikValues={setFormikValues}
                                  setSyncSignupValues={setSyncSignupValues}
                                  setReinitialize={setReinitialize}
                                  areaOfInterestApiCall={(level, interest, eduInterest, cerInterest) => areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
                                  apiCallBasedOnStudyingIn={(name, option) => apiCallBasedOnStudyingIn(name, option)}
                                />
                              </Col>
                            );
                          })
                        }
                        
                      
                      {tertairyCheckboxShow && tertiaryData && props.tertiaryChecboxData?.id &&
                        <CareersRegisterRadio
                          name={"tertiary_checkbox"}
                          localStorageData={formikValues.tertiary_checkbox}
                          setFieldValue={setFieldValue}
                          values={values}
                          errors={errors}
                          touched={touched}
                          constants={props.constants}
                          radioBtn={tertiaryData}
                          handleRadioChange={(item, id) =>
                            handleTertiaryChange(item, id)
                          }
                          tertiaryChecboxData={props.tertiaryChecboxData}
                          tertiaryChecboxLoading={props.tertiaryChecboxLoading}
                        />}
                    </Row>
                    <div className="careers_register_custom_checkbox">
                      <Field type="checkbox" id="terms" name="terms"
                        checked={isConsentChecked}
                        onChange={(e) => {
                          handleConsentCheckboxChange(e)
                        }}
                        required />
                      <label htmlFor="terms" className="careers_register_terms">
                        <span > I agree to Careers360’s <a className="careers_register_terms_and_condition" href="https://www.careers360.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy </a>
                          and <a className="careers_register_terms_and_condition" href="https://www.careers360.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms &
                            Conditions</a> and provide consent to be contacted for promotion via mail, sms, whatsapp, rcs etc.
                        </span>
                      </label>
                    </div>

                    <button
                      disabled={props.usersAuthentication && props.userAuthenticationEmail && props.userAccountLimitCheck?.authorization
                        && isConsentChecked && Object.keys(fieldErrors)?.length === 0 && (!props.postSignupDataLoading || props.signupDataError) ? false : true}
                      type="submit"
                      className={props.usersAuthentication && props.userAuthenticationEmail  && props.userAccountLimitCheck?.authorization && isConsentChecked
                        && Object.keys(fieldErrors)?.length === 0 && (!props.postSignupDataLoading || props.signupDataError) ?
                        "careers_register_valid_button careers_register_button"
                        : "careers_register_button"}
                      onClick={() => { signupDataPost(); }}
                    >
                      Get OTP
                    </button>

                    <p className="careers_register_account">
                      Already have a Careers360 account?{" "}
                      <a href={`/user/login${window.location.search}`}>Login</a> to continue
                    </p>
                  </>
                )}
                {props.postSignupData?.proceed &&
                  window.location.pathname.includes("/user/otp-verify") &&
                  <CareersRegisterOtpVerifyScreen
                    values={values}
                    domain={props.domain}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    otpGetClickedMobile={() => otpGetClickedMobile()}
                    geolocationData={props.geolocationData}
                    formikValues={formikValues}
                    otpSubmitMobile={() => otpSubmitMobile()}
                    otpSubmitEmail={() => otpSubmitEmail()}
                    loginDatas={props.loginDatas}
                    otpGetClickedEmail={() => otpGetClickedEmail()}
                    editMobile={editMobile}
                    editEmail={editEmail}
                    setEditMobile={setEditMobile}
                    setEditEmail={setEditEmail}
                    setRemoveTab={props.setRemoveTab}
                    setFormCurrentState={setFormCurrentState}
                    formCurrentState={formCurrentState}
                    postSignupData={props.postSignupData}
                    updateTouchedFields={updateTouchedFields}
                    setReinitialize={setReinitialize}
                    setFormikValues={setFormikValues}
                    setSyncSignupValues={setSyncSignupValues}
                    setReloadFlag = {setReloadFlag}
                    isMatch={isMatch}
                  />
                }

              </Form>
              </>
            );
          }}
        </Formik>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    dropdownData: state.userSignUpFields,
    usersAuthentication: state.usersCommonData?.userAuthentication,
    usersAuthenticationError: state.usersCommonData?.userAuthenticationError,
    userIps: state.usersCommonData?.userIp,
    geolocationData: state.usersCommonData?.geoLocation,
    postSignupData: state.userSignUpFields?.signupData,
    postSignupDataLoading: state.userSignUpFields?.signupDataLoading,
    signupDataError: state.userSignUpFields?.signupDataError,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
    loginDatas: state.usersCommonData?.loginData,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    tertiaryChecboxData: state.userSignUpFields?.tertiaryChecbox,
    tertiaryChecboxLoading: state.userSignUpFields?.tertiaryChecboxLoading,
    emailDomainDatas: state.usersCommonData?.emailDomainData,
    countryCodeData: state.usersCommonData?.countryCode,
    userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
    userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
    userAccountLimitCheck: state.usersCommonData?.userAccountLimit,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterSignUp);
